/**
 * @description 3个子配置，通用配置 || 网络配置 || 项目常量 导出
 */

const setting = require("./setting");
const network = require("./network");
const constants = require("./constants");
module.exports = Object.assign({}, setting, network, constants);
